// import { Component, OnDestroy, OnInit } from '@angular/core';
// import { NbMediaBreakpointsService, NbMenuService, NbSidebarService, NbThemeService } from '@nebular/theme';

// import { UserData } from '../../../@core/data/users';
// import { LayoutService } from '../../../@core/utils';
// import { map, takeUntil } from 'rxjs/operators';
// import { Subject } from 'rxjs';
// import { Router } from '@angular/router';
// import { NbDialogService } from '@nebular/theme';
// import { NotificationsModalComponent } from '../../../pages/layout/notifications/notifications-modal/notifications-modal.component';

// @Component({
//   selector: 'ngx-header',
//   styleUrls: ['./header.component.scss'],
//   templateUrl: './header.component.html',
// })
// export class HeaderComponent implements OnInit, OnDestroy {

//   private destroy$: Subject<void> = new Subject<void>();
//   userPictureOnly: boolean = false;
//   user: any;

//   themes = [
//     {
//       value: 'default',
//       name: 'Light',
//     },
//     {
//       value: 'dark',
//       name: 'Dark',
//     },
//     {
//       value: 'cosmic',
//       name: 'Cosmic',
//     },
//     {
//       value: 'corporate',
//       name: 'Corporate',
//     },
//   ];

//   currentTheme = 'default';

//   userMenu = [{ title: 'Profile' }, { title: 'Log out' }];

//   constructor(private sidebarService: NbSidebarService,
//     private menuService: NbMenuService,
//     private themeService: NbThemeService,
//     private userService: UserData,
//     private layoutService: LayoutService,
//     private breakpointService: NbMediaBreakpointsService,
//     private router: Router,
//   private dialogService: NbDialogService) {
//   }

//   ngOnInit() {
//     this.currentTheme = this.themeService.currentTheme;

//     this.userService.getUsers()
//       .pipe(takeUntil(this.destroy$))
//       .subscribe((users: any) => this.user = users.nick);

//     const { xl } = this.breakpointService.getBreakpointsMap();
//     this.themeService.onMediaQueryChange()
//       .pipe(
//         map(([, currentBreakpoint]) => currentBreakpoint.width < xl),
//         takeUntil(this.destroy$),
//       )
//       .subscribe((isLessThanXl: boolean) => this.userPictureOnly = isLessThanXl);

//     this.themeService.onThemeChange()
//       .pipe(
//         map(({ name }) => name),
//         takeUntil(this.destroy$),
//       )
//       .subscribe(themeName => this.currentTheme = themeName);

//       this.menuService.onItemClick()
//   .pipe(takeUntil(this.destroy$))
//   .subscribe((event) => {
//     if (event.item.title === 'Log out') {
//       this.handleLogout();
//     }

//     if (event.item.title === 'Profile') {
//       this.handleProfile(); // ⭐ your profile route
//     }

//   });
//   }

// //   handleLogout() {
// //   // Clear tokens if any
// //   localStorage.removeItem('token');
// //   localStorage.removeItem('user');

// //   // Redirect to login page
// //   this.router.navigate(['/auth/login']);
// // }


// handleLogout() {
//   localStorage.removeItem('authToken');  // ✔ Remove correct token

//   this.router.navigate(['/auth/login'], { replaceUrl: true }); // ✔ block back button
// }

// handleProfile() {
//   this.router.navigate(['/pages/layout/admin-profile'], { replaceUrl: true });
// }

// // openNotifications() {
// //   // this.dialogService.open(NotificationsModalComponent, {
// //   //   closeOnBackdropClick: true
// //   // });

// //   this.dialogService.open(NotificationsModalComponent, {
// //   hasBackdrop: true,
// //   closeOnBackdropClick: true,
// //   context: {},
// //   dialogClass: 'notif-right-drawer'
// // });
// // }


// openNotifications() {
//   this.dialogService.open(NotificationsModalComponent, {
//     dialogClass: 'notif-drawer',
//     closeOnBackdropClick: true,
//     closeOnEsc: true,
//   });
// }

//   ngOnDestroy() {
//     this.destroy$.next();
//     this.destroy$.complete();
//   }

//   changeTheme(themeName: string) {
//     this.themeService.changeTheme(themeName);
//   }

//   toggleSidebar(): boolean {
//     this.sidebarService.toggle(true, 'menu-sidebar');
//     this.layoutService.changeLayoutSize();

//     return false;
//   }

//   navigateHome() {
//     this.menuService.navigateHome();
//     return false;
//   }
// }


// import { Component, OnDestroy, OnInit } from '@angular/core';
// import { NbMediaBreakpointsService, NbMenuService, NbSidebarService, NbThemeService, NbDialogService } from '@nebular/theme';
// import { LayoutService } from '../../../@core/utils';
// import { map, takeUntil } from 'rxjs/operators';
// import { Subject } from 'rxjs';
// import { Router } from '@angular/router';
// import { NotificationsModalComponent } from '../../../pages/layout/notifications/notifications-modal/notifications-modal.component';
// import { ApiService } from '../../../services/api.service';

// @Component({
//   selector: 'ngx-header',
//   styleUrls: ['./header.component.scss'],
//   templateUrl: './header.component.html',
// })
// export class HeaderComponent implements OnInit, OnDestroy {

//   private destroy$: Subject<void> = new Subject<void>();
//   userPictureOnly: boolean = false;
//   user: any = {};

//   themes = [
//     { value: 'default', name: 'Light' },
//     { value: 'dark', name: 'Dark' },
//     { value: 'cosmic', name: 'Cosmic' },
//     { value: 'corporate', name: 'Corporate' },
//   ];

//   currentTheme = 'default';

//   userMenu = [
//     { title: 'Profile' },
//     // { title: 'Login' },
  
//     { title: 'Log out' },

//   ];

//   constructor(
//     private sidebarService: NbSidebarService,
//     private menuService: NbMenuService,
//     private themeService: NbThemeService,
//     private layoutService: LayoutService,
//     private breakpointService: NbMediaBreakpointsService,
//     private router: Router,
//     private dialogService: NbDialogService,
//     private api: ApiService,
//   ) {}

//   ngOnInit() {
//     this.currentTheme = this.themeService.currentTheme;

//     // Load admin profile into header
//     this.loadAdminProfile();

//     // Auto-refresh header when profile updates
//     if (this.api.profileUpdated$) {
//       this.api.profileUpdated$.subscribe(() => {
//         this.loadAdminProfile();
//       });
//     }

//     // Handle responsive picture view
//     const { xl } = this.breakpointService.getBreakpointsMap();
//     this.themeService.onMediaQueryChange()
//       .pipe(
//         map(([, currentBreakpoint]) => currentBreakpoint.width < xl),
//         takeUntil(this.destroy$),
//       )
//       .subscribe((isLessThanXl: boolean) => this.userPictureOnly = isLessThanXl);

//     // Update theme name on theme change
//     this.themeService.onThemeChange()
//       .pipe(
//         map(({ name }) => name),
//         takeUntil(this.destroy$),
//       )
//       .subscribe(themeName => (this.currentTheme = themeName));

//     // Menu actions (Profile / Logout)
//     this.menuService.onItemClick()
//       .pipe(takeUntil(this.destroy$))
//       .subscribe((event) => {
//         if (event.item.title === 'Log out') this.handleLogout();
//         if (event.item.title === 'Profile') this.handleProfile();
//         // if (event.item.title === 'Login') this.handleLogin();

//       });
//   }

//   // ============================
//   // LOAD ADMIN PROFILE (Name + Image)
//   // ============================
//   loadAdminProfile() {
//     const profile = JSON.parse(localStorage.getItem('adminProfile') || '{}');

//     this.user = {
//       name: profile.name || 'Admin',
//       picture: profile.photo || null,
//     };
//   }

  

//   // ============================
//   // LOGOUT HANDLER
//   // ============================
//   handleLogout() {
//     localStorage.removeItem('authToken');
//     this.router.navigate(['/auth/login'], { replaceUrl: true });
//   }

//   // ============================
//   // PROFILE PAGE REDIRECT
//   // ============================
//   handleProfile() {
//     this.router.navigate(['/pages/layout/admin-profile'], { replaceUrl: true });
//   }

//   // ============================
//   // OPEN NOTIFICATION DRAWER
//   // ============================
//   openNotifications() {
//     this.dialogService.open(NotificationsModalComponent, {
//       dialogClass: 'notif-drawer',
//       closeOnBackdropClick: true,
//       closeOnEsc: true,
//     });
//   }

//   ngOnDestroy() {
//     this.destroy$.next();
//     this.destroy$.complete();
//   }

//   // Theme switching
//   changeTheme(themeName: string) {
//     this.themeService.changeTheme(themeName);
//   }

//   // Sidebar toggle
//   toggleSidebar(): boolean {
//     this.sidebarService.toggle(true, 'menu-sidebar');
//     this.layoutService.changeLayoutSize();
//     return false;
//   }

//   navigateHome() {
//     this.menuService.navigateHome();
//     return false;
//   }
// }


// import { Component, OnDestroy, OnInit } from '@angular/core';
// import { NbMediaBreakpointsService, NbMenuService, NbSidebarService, NbThemeService, NbDialogService } from '@nebular/theme';
// import { LayoutService } from '../../../@core/utils';
// import { map, takeUntil } from 'rxjs/operators';
// import { Subject } from 'rxjs';
// import { Router } from '@angular/router';
// import { NotificationsModalComponent } from '../../../pages/layout/notifications/notifications-modal/notifications-modal.component';
// import { ApiService } from '../../../services/api.service';
// import { environment } from '../../../../environments/environment';

// @Component({
//   selector: 'ngx-header',
//   styleUrls: ['./header.component.scss'],
//   templateUrl: './header.component.html',
// })
// export class HeaderComponent implements OnInit, OnDestroy {

//   private destroy$ = new Subject<void>();
//   userPictureOnly = false;

//   user = {
//     name: '',
//     picture: ''
//   };

//   themes = [
//     { value: 'default', name: 'Light' },
//     { value: 'dark', name: 'Dark' },
//     { value: 'cosmic', name: 'Cosmic' },
//     { value: 'corporate', name: 'Corporate' },
//   ];

//   currentTheme = 'default';

//   userMenu = [
//     { title: 'Profile' },
//     { title: 'Log out' },
//   ];

//   constructor(
//     private sidebarService: NbSidebarService,
//     private menuService: NbMenuService,
//     private themeService: NbThemeService,
//     private layoutService: LayoutService,
//     private breakpointService: NbMediaBreakpointsService,
//     private router: Router,
//     private dialogService: NbDialogService,
//     private api: ApiService,
//   ) {}

//   ngOnInit() {
//     this.currentTheme = this.themeService.currentTheme;

//     this.loadAdminProfile();

//     this.api.profileUpdated$
//   .pipe(takeUntil(this.destroy$))
//   .subscribe(() => {
//     this.loadAdminProfile();
//   });


//     this.themeService.onMediaQueryChange()
//       .pipe(
//         map(([, bp]) => bp.width < this.breakpointService.getBreakpointsMap().xl),
//         takeUntil(this.destroy$),
//       )
//       .subscribe(isLess => this.userPictureOnly = isLess);

//     this.themeService.onThemeChange()
//       .pipe(
//         map(({ name }) => name),
//         takeUntil(this.destroy$),
//       )
//       .subscribe(theme => this.currentTheme = theme);

//     this.menuService.onItemClick()
//       .pipe(takeUntil(this.destroy$))
//       .subscribe(event => {
//         if (event.item.title === 'Log out') this.handleLogout();
//         if (event.item.title === 'Profile') this.handleProfile();
//       });
//   }

//   // ----------------------------------------------------------------
//   // LOAD ADMIN PROFILE (LIVE FROM API)
//   // ----------------------------------------------------------------
//   loadAdminProfile() {
//     this.api.getAdminProfile().subscribe({
//       next: (res: any) => {
//         const p = res.data;

//         this.user.name = p.name || 'Admin';

//         this.user.picture = p.image
//           ? environment.assetsUrl  + p.image
//           : ''; // fallback will be shown by nb-user
//       },
//       error: () => {
//         this.user = {
//           name: 'Admin',
//           picture: ''
//         };
//       }
//     });
//   }

//   // ----------------------------------------------------------------
//   // LOGOUT
//   // ----------------------------------------------------------------
//   handleLogout() {
//     localStorage.removeItem('authToken');
//     this.router.navigate(['/auth/login'], { replaceUrl: true });
//   }

//   // ----------------------------------------------------------------
//   // GO TO PROFILE PAGE
//   // ----------------------------------------------------------------
//   handleProfile() {
//     this.router.navigate(['/pages/layout/admin-profile']);
//   }

//   // ----------------------------------------------------------------
//   // OPEN NOTIFICATION DRAWER
//   // ----------------------------------------------------------------
//   openNotifications() {
//     this.dialogService.open(NotificationsModalComponent, {
//       dialogClass: 'notif-drawer',
//       closeOnBackdropClick: true,
//       closeOnEsc: true,
//     });
//   }

//   ngOnDestroy() {
//     this.destroy$.next();
//     this.destroy$.complete();
//   }

//   changeTheme(themeName: string) {
//     this.themeService.changeTheme(themeName);
//   }

//   toggleSidebar(): boolean {
//     this.sidebarService.toggle(true, 'menu-sidebar');
//     this.layoutService.changeLayoutSize();
//     return false;
//   }

//   navigateHome() {
//     this.menuService.navigateHome();
//     return false;
//   }
// }


import { Component, OnDestroy, OnInit } from '@angular/core';
import { NbMediaBreakpointsService, NbMenuService, NbSidebarService, NbThemeService, NbDialogService } from '@nebular/theme';
import { LayoutService } from '../../../@core/utils';
import { map, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { Router } from '@angular/router';
import { NotificationsModalComponent } from '../../../pages/layout/notifications/notifications-modal/notifications-modal.component';
import { ApiService } from '../../../services/api.service';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'ngx-header',
  styleUrls: ['./header.component.scss'],
  templateUrl: './header.component.html',
})
export class HeaderComponent implements OnInit, OnDestroy {

  private destroy$ = new Subject<void>();
  userPictureOnly = false;

  user = {
    name: '',
    picture: ''
  };

  themes = [
    { value: 'default', name: 'Light' },
    { value: 'dark', name: 'Dark' },
    { value: 'cosmic', name: 'Cosmic' },
    { value: 'corporate', name: 'Corporate' },
  ];

  currentTheme = 'default';

  userMenu = [
    { title: 'Profile' },
    { title: 'Log out' },
  ];

  constructor(
    private sidebarService: NbSidebarService,
    private menuService: NbMenuService,
    private themeService: NbThemeService,
    private layoutService: LayoutService,
    private breakpointService: NbMediaBreakpointsService,
    private router: Router,
    private dialogService: NbDialogService,
    private api: ApiService,
  ) {}

  ngOnInit() {
    this.currentTheme = this.themeService.currentTheme;

    // Load profile first time
    this.loadAdminProfile();

    // 🔥 Listen for profile update events (Fix header refresh issue)
    this.api.profileUpdated$
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => this.loadAdminProfile());

    this.themeService.onMediaQueryChange()
      .pipe(
        map(([, bp]) => bp.width < this.breakpointService.getBreakpointsMap().xl),
        takeUntil(this.destroy$),
      )
      .subscribe(isLess => this.userPictureOnly = isLess);

    this.themeService.onThemeChange()
      .pipe(
        map(({ name }) => name),
        takeUntil(this.destroy$),
      )
      .subscribe(theme => this.currentTheme = theme);

    this.menuService.onItemClick()
      .pipe(takeUntil(this.destroy$))
      .subscribe(event => {
        if (event.item.title === 'Log out') this.handleLogout();
        if (event.item.title === 'Profile') this.handleProfile();
      });
  }

  // ----------------------------------------------------------------
  // LOAD ADMIN PROFILE
  // ----------------------------------------------------------------
  loadAdminProfile() {
    this.api.getAdminProfile().subscribe({
      next: (res: any) => {
        const p = res.data;

        this.user.name = p.name || 'Admin';

        this.user.picture = p.image
          ? environment.assetsUrl + p.image
          : '';
      },
      error: () => {
        this.user = { name: 'Admin', picture: '' };
      }
    });
  }

  handleLogout() {
    localStorage.removeItem('authToken');
    this.router.navigate(['/auth/login'], { replaceUrl: true });
  }

  handleProfile() {
    this.router.navigate(['/pages/layout/admin-profile']);
  }

  openNotifications() {
    this.dialogService.open(NotificationsModalComponent, {
      dialogClass: 'notif-drawer',
      closeOnBackdropClick: true,
      closeOnEsc: true,
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  changeTheme(themeName: string) {
    this.themeService.changeTheme(themeName);
  }

  toggleSidebar(): boolean {
    this.sidebarService.toggle(true, 'menu-sidebar');
    this.layoutService.changeLayoutSize();
    return false;
  }

  navigateHome() {
    this.menuService.navigateHome();
    return false;
  }
}
